module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_12.71146c8c.pdf";